import { render, staticRenderFns } from "./RarityGem.vue?vue&type=template&id=1b446971&scoped=true&"
import script from "./RarityGem.vue?vue&type=script&lang=js&"
export * from "./RarityGem.vue?vue&type=script&lang=js&"
import style0 from "./RarityGem.vue?vue&type=style&index=0&id=1b446971&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b446971",
  null
  
)

export default component.exports